export default __webpack_public_path__ + "static/media/DUBeat.be9e5585.jpg";